import { createSelector } from "@reduxjs/toolkit"

export const selectGraphsByTabName = createSelector(
  [state => state.analytics.graphs.list.list, (_, tabName) => tabName],
  (graphs, tabName) => graphs.filter(graph => graph.tab === tabName)
)
